import React, { Component } from "react";
import "./about.scss";

class About extends Component {
  constructor() {
    super();
    this.scrollPage();
  }

  scrollPage() {
    window.scrollTo({
      top: 0
    });
  }
  render() {
    return (
      <div className="about">
        {/* page 1  */}
        <section className="page1">
          <div className="container-fluid">
            <div className="row">
              <div className="col-md-6">
                <div className="heading">
                  <h1>So what is Logipool? </h1>
                  <p>
                    A training institute in pune that prefers to coach students
                    practically on projects rather than theoretically by just
                    mugging up concepts. Logipool tries to help a beginner
                    overcome the hurdles they face when entering into a new
                    domain by providing support at every juncture.
                  </p>
                </div>
              </div>
              <div className="col-md-6">
                <div className="imgSection">
                  <img
                    src={require("../../images/Logipool-Banner-logo.png")}
                    alt=""
                  />
                </div>
              </div>
            </div>
          </div>
          <div className="container-fluid ">
            <div className="row">
              {/* <div className="col-md-2">
                <div className="page-1-info">
                  <div className="icon">
                    <img src={require("../../images/book icon.png")} alt="" />
                  </div>

                  <div className="info">
                    <h1>New Batches</h1>
                    <p>Batches starting from 2nd Feb.</p>

                    <a href="">Join Us</a>
                  </div>
                </div>
              </div> */}
              <div className="col-md-3">
                <div className="page-1-info">
                  <div className="icon">
                    <img
                      src={require("../../images//trophy icon.png")}
                      alt=""
                    />
                  </div>

                  <div className="info">
                    <h1>Top Courses</h1>
                    <p>
                      Get the finest advance courses that are in demand now.
                    </p>

                    <a href="">Join Us</a>
                  </div>
                </div>
              </div>
              <div className="col-md-3">
                <div className="page-1-info">
                  <div className="icon">
                    <img
                      src={require("../../images/placement icon.png")}
                      alt=""
                    />
                  </div>

                  <div className="info">
                    <h1>Placements</h1>
                    <p>Get to work in your dream company through us...!</p>
                    <a href="">Join Us</a>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>

        {/* page 2 */}

        <section className="story">
          <div className="container-fluid">
            <div className="row">
              <div className="col-md-6">
                <div className="leftSection">
                  <img
                    src={require("../../images/training student.png")}
                    alt=""
                  />
                </div>
              </div>
              <div className="col-md-6">
                <div className="rightSection">
                  <div className="containt">
                    <h1>Logipool Story</h1>
                    <p>
                      Welcome to the world of LOGIPOOL INFOTECH, where we
                      believe in providing high quality, job oriented
                      training and placement opportunities. At LOGIPOOL quality
                      and integrity comes first as being "the best in what we
                      do". Our trainers are certified experts, experienced
                      professionals with real-time projects.  LogiPool Infotech
                      is one of the leading IT Training, Placement, Staffing
                      department of TechnoGrowth Software Solution Pvt. Ltd.
                      (www. Technogrowth.com)for fresh graduate students as well
                      as working IT Professionals.
                    </p>
                    <a href="">Read more</a>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>
        {/*  infoSection  */}
        <section className="infoSection">
          <div className="container">
            <div className="row">
              <div className="col-md-6">
                <div className="contains">
                  <h1>Why prefer Logipool ?</h1>
                  <p>
                    We, as an institute do not believe in filling our batches
                    with many students. Logipool gives more importance to the
                    standard quality of teaching.
                    <br />
                    We give students exposure to many technologies and ensure
                    they are under the guidance of expert developers who have
                    good IT industry experience.
                  </p>
                </div>
              </div>
              <div className="col-md-6">
                <div className="contains">
                  <h1>Logipool courses</h1>
                  <p>
                    Courses covered in Logipool are taught from the elementary
                    level and finished only when the students become an expert.
                    Students get to explore the latest technology and frameworks
                    in the IT industry in detail.
                  </p>
                </div>
              </div>
            </div>
          </div>
        </section>
        {/* what Make Section*/}
        <section className="makeSection">
          <div className="container-fluid">
            <div className="row">
              <div className="col-md-5 offset-md-1">
                <div className="info">
                  <h1>
                    What makes us <span id="different">different?</span>{" "}
                  </h1>
                  <p>
                    Logipool not only sharpens students' hard skills but also
                    emphasises on soft skills. A student is how to present in an
                    interview, how to tackle tricky situations and how to groom
                    themselves.
                  </p>
                </div>
              </div>
              <div className="col-md-6">
                <div className="imgSection">
                  <img
                    src={require("../../images/training instructor.png")}
                    alt=""
                  />
                </div>
              </div>
            </div>
          </div>
        </section>
        {/* instructor */}
        <section className="instructor">
          <div className="container">
            <div className="row">
              <div className="heading">
                <h1>Our Best Instructor</h1>
                <p>
                  The speaker bio is typically used in the programs at
                  conferences, they may be used on the organization's website
                  when promoting the event.
                </p>
              </div>
            </div>
          </div>
          <div className="container-fluid">
            <div className="row">
              <div className="col-md-3">
                <div className="containt">
                  <div className="profile">
                    <img src={require("../../images/insturctor1.png")} alt="" />
                    <div className="info">
                      <h1>John Doe</h1>
                      <p>Designer, Marketo</p>
                    </div>
                  </div>
                </div>
              </div>
              <div className="col-md-3">
                <div className="containt">
                  <div className="profile">
                    <img src={require("../../images/insturctor2.png")} alt="" />
                    <div className="info">
                      <h1>John Doe</h1>
                      <p>Designer, Marketo</p>
                    </div>
                  </div>
                </div>
              </div>
              <div className="col-md-3">
                <div className="containt">
                  <div className="profile">
                    <img src={require("../../images/insturctor3.png")} alt="" />
                    <div className="info">
                      <h1>John Doe</h1>
                      <p>Designer, Marketo</p>
                    </div>
                  </div>
                </div>
              </div>
              <div className="col-md-3">
                <div className="containt">
                  <div className="profile">
                    <img src={require("../../images/insturctor4.png")} alt="" />
                    <div className="info">
                      <h1>John Doe</h1>
                      <p>Designer, Marketo</p>
                    </div>
                  </div>
                </div>
              </div>
              <div className="col-md-3">
                <div className="containt">
                  <div className="profile">
                    <img src={require("../../images/insturctor5.png")} alt="" />
                    <div className="info">
                      <h1>John Doe</h1>
                      <p>Designer, Marketo</p>
                    </div>
                  </div>
                </div>
              </div>
              <div className="col-md-3">
                <div className="containt">
                  <div className="profile">
                    <img src={require("../../images/insturctor6.png")} alt="" />
                    <div className="info">
                      <h1>John Doe</h1>
                      <p>Designer, Marketo</p>
                    </div>
                  </div>
                </div>
              </div>
              <div className="col-md-3">
                <div className="containt">
                  <div className="profile">
                    <img src={require("../../images/insturctor7.png")} alt="" />
                    <div className="info">
                      <h1>John Doe</h1>
                      <p>Designer, Marketo</p>
                    </div>
                  </div>
                </div>
              </div>
              <div className="col-md-3">
                <div className="containt">
                  <div className="profile">
                    <img src={require("../../images/insturctor8.png")} alt="" />
                    <div className="info">
                      <h1>John Doe</h1>
                      <p>Designer, Marketo</p>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>

        {/* our clients */}
        <section className="clients">
          <div className="container">
            <div className="row">
              <div className="heading">
                <h1>Our Clients</h1>
              </div>
            </div>
          </div>
          <div className="container">
            <div className="row">
              <div className="col-md-3 col-6">
                <div className="imgSection">
                  <img
                    src={require("../../images/AngularJS_logo.png")}
                    alt=""
                  />
                </div>
              </div>
              <div className="col-md-3 col-6">
                <div className="imgSection">
                  <img src={require("../../images/Node.js_logo.png")} alt="" />
                </div>
              </div>
              <div className="col-md-3 col-6">
                <div className="imgSection">
                  <img
                    src={require("../../images/icons8-ios-logo.png")}
                    alt=""
                  />
                </div>
              </div>
              <div className="col-md-3 col-6">
                <div className="imgSection">
                  <img src={require("../../images/React-icon.png")} alt="" />
                </div>
              </div>
            </div>
          </div>
        </section>
      </div>
    );
  }
}

export default About;
